// ======================================================================
// 📁 File: src/modules/ppe/components/material-flow/purchase/POLineItemsTable.js
// 📝 Purpose:
//   Purchase Order Line Items Table
//   - Add / Edit PO Lines
//   - Material search integration
//   - Auto tax integration from master
// ======================================================================

import React from "react";
import AsyncSearchSelect from "./AsyncSearchSelect";

// ===== FIX: RESTORE WORKING LOOKUP SERVICE (LIKE OLD BACKUP) =====
import lookupService from "../services/lookupService";

export default function POLineItemsTable({
  lines,
  setLines
}) {

  const addNewLine = () => {
    setLines([
      ...lines,
      {
        material_id: "",
        material_name: "",
        material_type: "",
        qty: "",
        uom: "",
        rate: "",
        discount_percent: "0",
        discount: "",

        // ===== TAX INTEGRATION CHANGE (NEW FIELDS ADDED) =====
        tax_classification_id: "",
        tax_code: "",
        gst_rate: "",
        cgst_rate: "",
        sgst_rate: "",
        igst_rate: ""
      }
    ]);
  };

  const updateLine = (index, field, value) => {
    const updated = [...lines];
    updated[index][field] = value;
    setLines(updated);
  };

  const updateLineWithRecalculation = (
  index,
  field,
  value
) => {

  const updated = [...lines];

  updated[index][field] = value;

  const qty = parseFloat(
    updated[index].qty || 0
  );

  const rate = parseFloat(
    updated[index].rate || 0
  );

  const grossAmount = qty * rate;

  const discountPercent = parseFloat(
    updated[index].discount_percent || 0
  );

  const discountAmount =
    (grossAmount * discountPercent) / 100;

  const taxableAmount =
    grossAmount - discountAmount;

  const gstRate = parseFloat(
    updated[index].gst_rate || 0
  );

  const gstAmount =
    (taxableAmount * gstRate) / 100;

  const lineTotal =
    taxableAmount + gstAmount;

  updated[index].discount =
  discountAmount.toFixed(2);

updated[index].discount_amount =
  discountAmount.toFixed(2);

updated[index].gross_amount =
  grossAmount;

updated[index].taxable_amount =
  taxableAmount;

  updated[index].gst_amount =
    gstAmount;

  updated[index].line_total =
    lineTotal;

  setLines(updated);
};

  const removeLine = (index) => {
    const updated = lines.filter((_, i) => i !== index);
    setLines(updated);
  };

  // ===== NEW FUNCTION: CALCULATE GST AMOUNT PER LINE =====
  
  const calculateDiscountPercent = (
  index,
  value
) => {

  const updated = [...lines];

  const qty = parseFloat(
    updated[index].qty || 0
  );

  const rate = parseFloat(
    updated[index].rate || 0
  );

  const grossAmount = qty * rate;

  let discountPercent =
    parseFloat(value || 0);

  if (discountPercent > 100) {
    discountPercent = 100;
  }

  const discountAmount =
    (grossAmount * discountPercent) / 100;

  const taxableAmount =
    grossAmount - discountAmount;

  const gstRate = parseFloat(
    updated[index].gst_rate || 0
  );

  const gstAmount =
    (taxableAmount * gstRate) / 100;

  const lineTotal =
    taxableAmount + gstAmount;

  updated[index].discount_percent =
    discountPercent;

  // IMPORTANT
  updated[index].discount =
    discountAmount.toFixed(2);

  updated[index].discount_amount =
    discountAmount.toFixed(2);

  updated[index].gross_amount =
    grossAmount;

  updated[index].taxable_amount =
    taxableAmount;

  updated[index].gst_amount =
    gstAmount;

  updated[index].line_total =
    lineTotal;

  setLines(updated);
};

  
  const getTaxableAmount = (l) => {

  const qty = parseFloat(
    l.qty || 0
  );

  const rate = parseFloat(
    l.rate || 0
  );

  const discount = parseFloat(
    l.discount || 0
  );

  const grossAmount = qty * rate;

  return (
    grossAmount - discount
  ).toFixed(2);
};

  const getGSTAmount = (l) => {
    const qty = parseFloat(l.qty || 0);
    const rate = parseFloat(l.rate || 0);
    const discount = parseFloat(l.discount || 0);
    const gstRate = parseFloat(l.gst_rate || 0);

    let amount = qty * rate;
    amount = amount - discount;

    return ((amount * gstRate) / 100).toFixed(2);
  };

  // ===== NEW FUNCTION: CALCULATE LINE TOTAL INCLUDING GST =====
  const getLineTotal = (l) => {
    const qty = parseFloat(l.qty || 0);
    const rate = parseFloat(l.rate || 0);
    const discount = parseFloat(l.discount || 0);
    const gstRate = parseFloat(l.gst_rate || 0);

    let amount = qty * rate;
    amount = amount - discount;

    const gstAmount = (amount * gstRate) / 100;

    return (amount + gstAmount).toFixed(2);
  };

  return (
    <div className="mt-3">
      <div className="d-flex justify-content-between mb-2">
        <h6>Line Items</h6>

        <button
          className="btn btn-sm btn-outline-primary"
          onClick={addNewLine}
        >
          + Add Line
        </button>
      </div>

      <table
          className="table table-bordered table-sm po-line-table"
          style={{
            tableLayout: "auto"
          }}
        >
        <thead>
          <tr>
            <th style={{ width: "28%" }}>Material</th>
            <th style={{ width: "6%" }}>Type</th>
            <th style={{ width: "5%" }}>Qty</th>
            <th style={{ width: "5%" }}>UOM</th>
            <th style={{ width: "7%" }}>Rate</th>
            <th style={{ width: "6%" }}>Disc %</th>
            <th style={{ width: "8%" }}>Discount</th>
            <th style={{ width: "8%" }}>Taxable</th>
            <th style={{ width: "8%" }}>HSN/SAC</th>
            <th style={{ width: "6%" }}>GST %</th>
            <th style={{ width: "8%" }}>GST Amount</th>
            <th style={{ width: "8%" }}>Total</th>
            <th style={{ width: "4%" }}>Action</th>
        </tr>
        </thead>

        <tbody>
        {lines.map((l, i) => (
          <tr key={i}>
            <style>
            {`
            .po-line-table td,
            .po-line-table th {
              padding: 2px !important;
              vertical-align: middle;
            }

            .po-line-table .form-control {
              padding-left: 4px !important;
              padding-right: 4px !important;
            }
            `}
            </style>

              <td style={{ padding: "2px" }}>

                {/* ===== FIX: USE lookupService INSTEAD OF fetch (RESTORED WORKING LOGIC) ===== */}

                <AsyncSearchSelect
                  placeholder="Search material..."

                  loadOptions={lookupService.searchMaterials}

                  labelKey="name"
                  valueKey="id"

                  value={{
                    id: l.material_id,
                    name: l.material_name
                  }}

                  onChange={(item) => {
                    updateLine(i, "material_id", item.id);
                    updateLine(i, "material_name", item.name);
                    updateLine(i, "material_type", item.material_type);
                    updateLine(i, "uom", item.uom);

                    // ===== TAX INTEGRATION CHANGE (AUTO FILL FROM API) =====
                    updateLine(i, "tax_classification_id", item.tax_classification_id);
                    updateLine(i, "tax_code", item.tax_code);
                    updateLine(i, "gst_rate", item.gst_rate);
                    updateLine(i, "cgst_rate", item.cgst_rate);
                    updateLine(i, "sgst_rate", item.sgst_rate);
                    updateLine(i, "igst_rate", item.igst_rate);
                  }}
                />

              </td>

              <td>
                <input
                  className="form-control form-control-sm"
                  value={l.material_type}
                  readOnly
                />
              </td>

              <td>
                <input
                  type="number"
                  className="form-control form-control-sm"
                  value={l.qty}
                  onChange={(e) =>
                      updateLineWithRecalculation(
                        i,
                        "qty",
                        e.target.value
                      )
                    }
                />
              </td>

              <td>
                <input
                  className="form-control form-control-sm"
                  value={l.uom}
                  readOnly
                />
              </td>

              <td>
                <input
                  type="number"
                  className="form-control form-control-sm"
                  value={l.rate || 0}
                  onChange={(e) =>
                    updateLineWithRecalculation(
                      i,
                      "rate",
                      e.target.value
                    )
                  }
                />
              </td>
              <td>
              <input
                type="number"
                className="form-control form-control-sm"
                value={l.discount_percent || ""}
                onChange={(e) =>
                  updateLineWithRecalculation(
                    i,
                    "discount_percent",
                    e.target.value
                  )
                }
              />
            </td>

              <td>
                <input
                  type="number"
                  className="form-control form-control-sm"
                  value={l.discount}
                  readOnly
                  onChange={(e) => {

                    const qty =
                      parseFloat(l.qty || 0);

                    const rate =
                      parseFloat(l.rate || 0);

                    const grossAmount =
                      qty * rate;

                    let value =
                      parseFloat(
                        e.target.value || 0
                      );

                    if (value > grossAmount) {
                      value = grossAmount;
                    }

                    updateLine(
                      i,
                      "discount",
                      value
                    );

                  }}
                />
              </td>
              <td>
                <input
                  className="form-control form-control-sm"
                  value={getTaxableAmount(l)}
                  readOnly
                />
              </td>    
              {/* ===== TAX INTEGRATION CHANGE (DISPLAY ONLY – READ ONLY) ===== */}

              <td>
                <input
                  className="form-control form-control-sm"
                  value={l.tax_code || ""}
                  placeholder="HSN Code"
                  readOnly
                />
              </td>

              <td>
                <input
                  className="form-control form-control-sm"
                  value={l.gst_rate || ""}
                  placeholder="GST %"
                  readOnly
                />
              </td>

              {/* ===== NEW GST AMOUNT DISPLAY ===== */}
              <td>
                <input
                  className="form-control form-control-sm"
                  value={getGSTAmount(l)}
                  readOnly
                />
              </td>

              {/* ===== NEW LINE TOTAL DISPLAY ===== */}
              <td>
                <input
                  className="form-control form-control-sm"
                  value={getLineTotal(l)}
                  readOnly
                />
              </td>

              <td className="text-center">
                <button
                  className="btn btn-sm btn-danger"
                  onClick={() => removeLine(i)}
                >
                  ✕
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
